// @flow
import React, { PureComponent } from 'react';
import { Wrap, Image } from './BlendControl.styled';

type Props = {
  isActive: boolean,
  type: ?string,
  onClick: (type: string) => void,
};

class BlendControl extends PureComponent<Props> {
  static defaultProps = {
    type: 'none',
  };

  getUrlForType = (blendType: string) => {
    if (blendType === 'multiply' || blendType === 'screen') {
      return `/assets/images/blend-${blendType}.png`;
    }

    return `/assets/images/blend-none.png`;
  };

  render() {
    const { type, onClick, isActive } = this.props;
    return (
      <Wrap isActive={isActive} onClick={() => onClick(type)}>
        <Image alt={type} src={this.getUrlForType(type)} />
      </Wrap>
    );
  }
}

export default BlendControl;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/components/BlendControl/BlendControl.js